<app-loading />
<div class="pos-relative w-100 max-width-900">
    <main>
        <router-outlet />
    </main>

    @if (showLogoAndVersion) {
    <footer
        class="pos-fixed d-flex flex-column ai-center jc-center f-s-12 w-100 bottom-1 max-width-900 bg-app p-10 text-text-primary">
        <img class="w-15" [src]="isDarkMode ? 'assets/images/logo-dark.png' : 'assets/images/logo.png'" alt="Logo">
        {{appVersion}}
    </footer>
    }
</div>